// extracted by mini-css-extract-plugin
module.exports = {"Badges":"Home_Badges__2_nZx","SpinnerContainer":"Home_SpinnerContainer__HBMGg"};